import React, { useEffect, useState } from "react"
import { Icon } from "@mui/material"
import { styled } from "@mui/material/styles"
import useInformation from "hooks/useInformation"
import { FormattedMessage } from "react-intl"

const UpdateIcon = styled(Icon)(({ theme }) => ({
  display: "inline",
  padding: "4px 6px",
  color: "#fff",
  textAlign: "center",
  backgroundColor: "#ab1b1b",
  borderRadius: "4px",
  fontSize: "11px",
  "&:hover": {
    textDecoration: "none",
  },
}))

const InfoIconUpdate = () => {
  const [invisible, setInvisible] = useState(true)
  const { information } = useInformation()
  const { isRead } = information

  useEffect(() => {
    setInvisible(isRead)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRead])

  return (
    !invisible && (
      <UpdateIcon>
        <FormattedMessage id="InfoIconUpdate.Text" />
      </UpdateIcon>
    )
  )
}

export default InfoIconUpdate
